import { Spinner } from 'Components/Spinner/Spinner';
import React from 'react';
import { SpinnerStyled } from '../style';
import {
  Arrow,
  OrderListItem,
  OrderListWrapper,
  OrderParam,
  Price,
  Profit,
  Symbol,
  Time,
} from './OrderList.style';

export default function OrderList({
  data,
  instrument,
  handleChangeInstrument,
}) {
  return (
    <OrderListWrapper>
      {!data?.length && (
        <SpinnerStyled>
          <Spinner />
        </SpinnerStyled>
      )}
      {data?.map((item, i) => (
        <OrderListItem
          key={item.instrument + i}
          isActive={instrument === item.instrument}
          onClick={handleChangeInstrument(item.instrument)}
        >
          <Symbol>{item.instrument.slice(0, 6)}</Symbol>
          <Price>{item.close.toFixed(5)}</Price>
          <OrderParam red={item.change_point < 0 ? 'true' : ''}>
            <Arrow />
            {' '}{item.change_point.toFixed(5)}
          </OrderParam>
          <Profit red={item.change_point < 0 ? 'true' : ''}>
            {item.change_point > 0 ? '+' : ''}
            {item.change_percent.toFixed(2)}%
          </Profit>
          <Time red={item.change_point < 0 ? 'true' : ''} />
        </OrderListItem>
      ))}
    </OrderListWrapper>
  );
}
